export default __webpack_public_path__ + "static/media/bodyforce.4f4ac2d2.jpg";